import { ContentPanel } from '../container'
import { useActions } from '../../store'

const { env } = window

/** the fallback component to be displayed for ErrorBoundary. */
const ErrorFallback = () => {
  const { setError } = useActions()

  setError('An unexpected error has occurred')

  return (
    <>
      <ContentPanel className='error-panel'>
        <p>Please reload/refresh this page in your browser.</p>
        <p>
          If the error persists,
          <a
            href={env.supportUrl}
            target='_blank'
            rel='noopener noreferrer'
            className='px-1'
          >
            Contact Us
          </a>
          for assistance
        </p>
      </ContentPanel>
    </>
  )
}

export { ErrorFallback }
